import { render, staticRenderFns } from "./CodeSample.vue?vue&type=template&id=7fa5da1c"
import script from "./CodeSample.vue?vue&type=script&lang=js"
export * from "./CodeSample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports